import "./styles.less";

import { LeadButtons } from "../../../Components/Property/InformationRequest/LeadButtons/web";
import React, { useEffect } from "react";

export const PropertyAffixBottom = ({ id, mode, isProject = false, owner }) => {
	useEffect(() => {
		const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
		if (isIOS && window.scrollY === 0) {
			window.scrollBy(0, 1);
		}
	}, []);

	return (
		<div className="pd_affix_bottom">
			<div className="pd_affix_bottom_content">
				<LeadButtons
					id={id}
					owner={owner}
					isProject={isProject}
					isInListing
					source="card"
					ctaToShow={{
						phone: true,
						whatsapp: true,
						contact: true
					}}
				/>
			</div>
		</div>
	);
};
